import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/css';

const overlayStyle = css`
  position: fixed;
  background: #535250;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  opacity: 0.5;
`;

const Loader = ({ useOverlay }) => {
  return (
    <>
      {useOverlay && <div className={overlayStyle}></div>}
      <div className="spinner"></div>
    </>
  );
};

Loader.propTypes = {
  useOverlay: PropTypes.bool,
};

Loader.defaultProps = {
  useOverlay: false,
};

export default Loader;
